import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — resets window scroll to (0, 0) on every route change.
 * Fixes the SPA quirk where navigating between pages preserves scroll
 * position from the previous page.
 * Ignores hash-based navigation so in-page anchors (#chambers) still work.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
